<template>
  <div style="width: 100%">
    <div @click="showTimePicker" :light="true" class="wmq-date-picker" :class="colorClass">
      <div class="date-display-style" style="font-size: 14px">{{ value ? value.join('至') : placeholder }}</div>
      <div v-if="value && clearable" class="sprite icon-close wmq-date-picker-clear" style="width: 10%;" @click="reset"></div>
    </div>
    <van-popup
      v-model="showBottom"
      close-icon="close"
      position="bottom"
      :class="buttonClasses"
    >
      <van-datetime-picker
        v-if="which === 'start'"
        v-model="startDate"
        :type="type"
        title="选择开始时间"
        @confirm="startConfirm"
        @cancel="cancelHandle"
        :min-date="minDate"
        :max-date="maxDate"
      />
      <van-datetime-picker
        v-if="which === 'end'"
        v-model="endDate"
        :type="type"
        title="选择结束时间"
        @confirm="endConfirm"
        @cancel="cancelHandle"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

  </div>
</template>

<script>
export default {
  name: 'DateRangePicker',
  props: {
    valueFormatter: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    placeholder: {
      type: String,
      default: '请选择日期'
    },
    type: {
      type: String,
      default: 'year-month'
    },
    value: {
      type: Array,
      default: null
    },
    fontSizeClass: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: '9999-12-31'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      datePicker: null,
      showBottom: false,
      startDate: new Date(),
      endDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2099, 0, 1),
      which: 'start',
      buttonClasses: 'default-mode'
    }
  },
  created() {
    this.checkOrientation() // 创建组件时立即检查一次
    window.addEventListener('resize', this.checkOrientation) // 监听窗口大小变化
  },
  destroyed() {
    window.removeEventListener('resize', this.checkOrientation) // 移除监听器
  },
  mounted () {

  },
  computed: {
    colorClass() {
      return this.value ? 'color-black' : 'color-gray'
    }
  },
  methods: {
    /**
       *  监听屏幕旋转
       */
    checkOrientation() {
      const orientation = window.matchMedia('(orientation: landscape)')

      if (orientation.matches) {
        this.buttonClasses = 'landscape-mode'
      } else {
        this.buttonClasses = 'default-mode'
      }
    },
    /**
     * 重置日期选择器的值为当前已选中的值
     */
    resetDatePickerValue() {
      this.startDate = this.value?.[0] ? new Date(this.value[0]) : new Date()
      this.endDate = this.value?.[1] ? new Date(this.value[1]) : new Date()
    },
    showTimePicker() {
      this.resetDatePickerValue()
      this.which = 'start'
      this.showBottom = true
    },
    startConfirm() {
      // 只重置结束日期,保留用户刚选择的开始日期
      this.endDate = this.value?.[1] ? new Date(this.value[1]) : new Date()
      this.showBottom = true
      this.which = 'end'
    },
    cancelHandle() {
      this.showBottom = false
      this.which = 'start'
      this.resetDatePickerValue()
    },
    endConfirm() {
      this.showBottom = false
      const res = []
      res[0] = this.$dayjs(this.startDate).format(this.valueFormatter)
      res[1] = this.$dayjs(this.endDate).format(this.valueFormatter)
      this.$emit('updateValue', res)
    },
    reset(e) {
      this.$emit('updateValue', null)
      e.stopPropagation()
    }
  }
}
</script>

<style lang="stylus" scope>
.wmq-date-picker {
    text-align: left;
    font-size: 28px;
    background-color: #fff;
    border: 1px solid #eee;
    width: 100%;
    display: flex;
    position: relative;
    min-height: 40px;
    height: auto;
    padding: 8px 10px;
    align-items: center;
}
.wmq-date-picker-clear {
    height: 42px;
    width: 42px;
    line-height: 60px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.date-display-style {
    white-space: normal;
    word-break: break-all;
    line-height: 1.5;
    width: 90%;
}
.color-gray {
    color: #64748b !important
}
.color-black {
    color: #1e293b !important
}
.default-mode{
    height: 40%;
}
.landscape-mode{
    height: 90%;
}
</style>
